import React from 'react'
import { connect } from 'react-redux'

import { cl } from '../../../../utilities/cl'

import Video from './Video'
import VideoExtra from './VideoExtra'
import VideoTheme from './VideoTheme'
import Line from './Line'

import Place from '../../../../components/Space/Place'
import Empty from '../../../../components/Space/Empty'

import SlideMenu from '../../../../components/SlideMenu'
import ObjectsMenu from '../../../../components/ObjectsMenu'

import { disableBlocks, enableBlocks } from '../../../../store/AdvertPage/actions'
import { addVideoToAdvert, addVideoToExtra } from '../../../../store/ContentAllVideolists/actions'
import { toggleHideEnded } from '../../../../store/Tracks/actions'

class What extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            empty: false
        }
        this.ref = React.createRef();
        this.setEmptyMode = this.setEmptyMode.bind(this)
    }

    componentDidUpdate() {
        const {
            searchFounded,
            searchValue
        } = this.props

        //мой вариант
        // this.setEmptyMode(searchValue ? !!!searchFounded.length  : false)

    }

    setEmptyMode(mode) {
        if (!mode) {
            this.setState(state => {
                if (state.empty) {
                    return { empty: false }
                }
            })
        } else {
            this.setState(state => {
                if (!state.empty) {
                    return { empty: true }
                }
            })
        }
    }

    render() {
        const {
            searchValue,
            disableBlocks,
            enableBlocks,
            addVideoToAdvert: addVideoToAdvertInner,
            toggleHideEnded
        } = this.props
        const {
            empty
        } = this.state

        const hideContent = cl({ "d-none": empty })
        const placeHolder = cl({ "d-none": !empty })



        const onVideoThemeContentCollapsableChanged = (opened) => {

            if (opened)
                disableBlocks()
            else
                enableBlocks()
        }

        const openFirst = () => {
            if (this.ref.current) {

                const parentElement = document.querySelector('.Space__Place');

                if (parentElement) {
                    const togglers = parentElement.querySelectorAll(".Collapsible .toggle-active-1")


                    togglers[0].click()
                    togglers[1].click()



                }

            }
        }

        const addVideoToAdvert = (data) => {
            addVideoToAdvertInner({ ...data, callback: openFirst });
            // openFirst();
        }


        return (
            <div ref={this.ref}            >
                {/* 1 */}

                <Place
                    number={1}
                    className={cl(
                        "AdvertWhat",
                        { "search-active": !!searchValue }
                    )}
                >
                    <ObjectsMenu />

                    <SlideMenu
                        activeItem={1}
                        className={hideContent}

                        items={[
                            {
                                title: "Ролики",
                                content: <Video title="Ролики" className={hideContent} active placeNumber={1} toggleHideEnded={toggleHideEnded} />
                            },
                            {
                                title: "Тематические ролики",
                                content: <VideoTheme title="Тематические ролики" className={hideContent} placeNumber={2} onChangeCollapsible={onVideoThemeContentCollapsableChanged} addVideoToAdvert={addVideoToAdvert} />
                            },
                            {
                                title: "Экстренные ролики",
                                content: <VideoExtra title="Экстренные ролики" className={hideContent} placeNumber={3} onChangeCollapsible={onVideoThemeContentCollapsableChanged} />
                            },
                            // {
                            //     title: "Бегущая строка",
                            //     content: <Line className={ hideContent } placeNumber={ 1 } />
                            // }
                        ]}
                    />

                    <Empty className={placeHolder}>
                        Роликов с таким названием не найдено
                    </Empty>
                </Place>
            </div>
        )
    }
}

const stateToProps = state => ({    
    searchValue: state.search["tracks"].value,
    searchFounded: [...state.search["tracks"].founded],
})

const actionsToProps = { disableBlocks, enableBlocks, addVideoToAdvert, toggleHideEnded }

export default connect(stateToProps, actionsToProps)(What)